import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

import { UserService } from '../shared/services/user.service';
import { SessionService } from '../shared/services/session.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    LoginData: FormGroup;
    error: boolean = false;
    errorMsg: string;
    cookieEnabled: boolean = true;
    hideUI: boolean = false;

    constructor(private userService: UserService, private sessionService: SessionService, private router: Router) {
        this.LoginData = new FormGroup({
            'username': new FormControl(),
            'password': new FormControl(),
            'remembered': new FormControl(true)
        });

        this.cookieEnabled = navigator.cookieEnabled;
        if (!this.cookieEnabled){
            document.cookie = "testcookie";
            this.cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
        }

        if(this.sessionService.checkStorageSession() && this.sessionService.checkStorageRefreshToken()) {
            this.hideUI = true;
            let tmprouter = this.router;

            this.sessionService.refreshToken()
                .subscribe(
                    data => {
                        let typeCaster: any = data;
                        this.sessionService.destroySessionCookie(false);
                        this.sessionService.rememberUser(typeCaster.accessToken);
                        this.sessionService.rememberRefreshToken(typeCaster.refreshToken);
                        this.sessionService.setSessionCookie(typeCaster.accessToken, typeCaster.expiresInSeconds);
                        this.sessionService.setRefreshToken(typeCaster.refreshToken);
                        this.router.navigate(['/dashboard']);
                    },
                    error => {
                        this.hideUI = false;
                        this.error = true;
                        localStorage.removeItem('user_token_admin');
                        localStorage.removeItem('refresh_token_admin');
                        localStorage.removeItem('merchantId');
                        if('Forbidden' === error.message && 136 === error.code) {
                            this.errorMsg = 'Account has been suspended'
                        } else {
                            this.errorMsg = error.message;
                        }
                    }
            );
        }
    }

    ngOnInit() {}

    onSubmit() {
        let username: string = this.LoginData.value.username;
        let password: string = this.LoginData.value.password;

        if (username && password) {
            username = username.trim();
            password = password.trim();
        }
        this.hideUI = true;
        localStorage.removeItem('user_token_admin');
        localStorage.removeItem('refresh_token_admin');
        localStorage.removeItem('merchantId');
        if(this.LoginData.value.username != null) {
            this.LoginData.value.username = this.LoginData.value.username.toLowerCase();
        }
        if(this.LoginData.value.password != null) {
            this.LoginData.value.password = encodeURIComponent(this.LoginData.value.password);
        }
        let tmprouter = this.router;
        this.userService.userLogin(this.LoginData.value)
            .subscribe(
            data => {
                this.sessionService.destroySessionCookie(true);
                this.sessionService.clearAllSorting();
                if (this.LoginData.value.remembered === true) {
                    this.sessionService.rememberUser(data.accessToken);
                    this.sessionService.rememberRefreshToken(data.refreshToken);
                    this.sessionService.setSessionCookie(data.accessToken, data.expiresInSeconds);
                    this.sessionService.setRefreshToken(data.refreshToken);
                } else {
                    this.sessionService.setSessionCookie(data.accessToken, data.expiresInSeconds);
                }

                this.sessionService.addUserType(data.type);
                this.userService.getTimeZone().subscribe(
                    data => {
                        localStorage.setItem('timezone', data.zone)
                        tmprouter.navigate(['/dashboard']);
                    },
                     error => {
                         localStorage.setItem('timezone', 'Pacific Time (-8)')
                         tmprouter.navigate(['/dashboard']);
                    }
                );
            },
            error => {
                this.hideUI = false;
                this.error = true;
                if('Forbidden' === error.message && 136 === error.code) {
                    this.errorMsg = 'Account has been suspended'
                } else {
                    this.errorMsg = error.message;
                }

            }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts